import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useRouteAnnouncer(getTitle) {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    let title = '';
    try {
      title = typeof getTitle === 'function' ? getTitle(location) : '';
    } catch (e) {
      title = '';
    }
    if (!title) title = document.title || location.pathname || 'Page';
    const evt = new CustomEvent('a11y:route-change', { detail: { title, path: location.pathname } });
    if (typeof window !== 'undefined') window.dispatchEvent(evt);
  }, [location, getTitle]);
}
